<template>
    <div style="height: 100%;">
        <v-container fluid>
            <v-layout>
                <!-- Overview by month -->
                <!-- Not implemented, all the information is available
                     on the billing tab. Left for possible future needs. -->
                <v-flex xs6 pr-1 v-if="false">
                  <v-layout>
                    <v-flex xs12>
                      <v-card>
                        <dashboard-overview
                        @newEventData="handleEventData($event)"
                        ></dashboard-overview>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <!-- Contracts sorted by most time since billing -->
                <v-flex xs6 pl-1>
                    <v-card pa-8>
                      <dashboard-contract-view
                      v-if="is_settings"
                      :list="list_id"
                      editpath="/billing/contracts/list/"
                      :disable-import="true"
                      :chosen_headers="contract_headers"
                      :chosen_items="contract_items"
                      ></dashboard-contract-view>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>
  
  <script>
  import DashboardContractView from './components/DashboardContractView.vue'
  import DashboardOverview from './components/DashboardOverview.vue';
  import SettingsModel from '@/models/settings.js';

  export default {
    data() {
      return {
        channel: undefined,
        contract_headers: [
        {text: 'Title', value: 'title', align: 'left'}, 
        {text: 'Customer', value: 'customer_name', align: 'left'},
        {text: 'Last Billed', value: 'last_billed', align: 'left'}
        ],
        contract_items: [
        {value: 'title', path: 'data.title', type: 'text'},
        {value: 'customer_name', path: 'data.customer.name', type: 'text'},
        {value: 'last_billed', path: 'data.last_billed', type: 'timestamp'}
        ],
      }
    },
    components: {
      DashboardContractView,
      DashboardOverview
    },
    methods: {
      handleEventData (e) {
        console.log(e);
      }
    },
  
    computed: {
      // Settings
      is_settings() {
        if (this.settings.length > 0) return true;
        return false;
      },
      settings() {
        return SettingsModel.list("billing_config");
      },
      list_id() {
        console.log(this.settings);
        return this.settings[0].value.contracts_list_id;
      }
  
    }
  }
  </script>
  